module.exports = __webpack_public_path__ + "static/media/push-icon.67fc2e63.svg";